<template>
  <main id="fullview">
    <router-view />
    <div class="container-fluid" v-if="authState?.isAuthenticated">
      <firstdashboard v-show="showText1"></firstdashboard>
      <seconddashboard v-show="!showText1"></seconddashboard>
    </div>
  </main>
</template>
<script>
import Firstdashboard from "./components/Firstdashboard.vue";
import Seconddashboard from "./components/Seconddashboard.vue";
export default {
  name: "App",
  components: {
    Firstdashboard,
    Seconddashboard,
  },
  data: () => ({
    showText1: true,
  }),

  mounted() {
     setInterval(() => {
       this.showText1 = !this.showText1;
    }, 30000);
  },
};
</script>
<style scoped>
.container-fluid {
  width: 97%;
  max-width: 100%;
  padding: 0;
  margin: 0 auto;

}
#fullview{
  height: 100vh;
  overflow:hidden;
}

</style>